import React, { useEffect } from 'react';
import './MembershipSucess.css';
import { BASE_URL } from './Config';
import { useNavigate } from 'react-router-dom';

export default function MembershipSucess() {


    const navigate = useNavigate();

    useEffect(() => {
        const timer = setTimeout(() => {
            navigate('/'); // Replace with your Charges page route
        }, 5000); // 5000ms = 5 seconds

        // Cleanup if component unmounts before timeout
        return () => clearTimeout(timer);
    }, [navigate]);


    return (
        <div className='card-body'>
            <div className="card">
                {/* Logo */}
                <div className="logo">
                    <img src={`${BASE_URL}/uploads/logo/icon.png`} alt="Fast Trade Logo" style={{ width: "100%", height: "100px", objectFit: "contain" }} />
                </div>

                {/* Approved Icon */}
                <div className="status-icon">
                    <span>✔</span>
                </div>

                {/* Message */}
                <h1>Payment Approved</h1>
                <p style={{ fontWeight: 600 }}>Your transaction was successful.</p>
                <p>Thank you for using the Fast Trade online payment service.</p>

                <div className="divider"></div>

                {/* Footer */}
                <div className="footer">
                    Payment powered by <a href="#">Paymob</a>
                </div>
            </div>
        </div>
    );
}
